module.exports = __webpack_public_path__ + "static/media/prize.ac15a563.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/springImage/prize.png
// module id = 963
// module chunks = 0